export default {"src":"/_next/static/media/Insta.5439c72a.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};